import { render, staticRenderFns } from "./AsignaturaAgregarForm.vue?vue&type=template&id=c07d5616"
import script from "./AsignaturaAgregarForm.vue?vue&type=script&lang=js"
export * from "./AsignaturaAgregarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports